export default { sha: '54fa4482e2db1898dfc06b565c2f3c166c298fe4', buildNumber: 'undefined' }
